<template>
  <Section
    :id="id"
    :header="t('orders.itinerary')"
    class="order-detail-section order-detail-itinerary"
    data-class="flex flex-column flex-gap-1"
  >
    <ShipOrderItineraryLoadingCard v-if="shipOrders.loading" />
    <p v-else-if="!shipOrders.data?.length">
      {{ t('common.noParam', { param: t('shipOrders.shipOrders', 2) }) }}
    </p>

    <ShipOrderItineraryCard
      v-for="shipOrder in shipOrders.data"
      :key="shipOrder.id"
      :ship-order="shipOrder"
      :shipments="shipments"
      class="elevated"
      expanded
    />
  </Section>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Loadable } from '@rygen/rygen-ui/model';

import { ShipOrder, Shipment } from '@/model';

import ShipOrderItineraryCard from '@/components/order/itinerary/ShipOrderItineraryCard.vue';
import ShipOrderItineraryLoadingCard from '@/components/order/itinerary/ShipOrderItineraryLoadingCard.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  shipOrders: {
    type: Object as PropType<Loadable<ShipOrder[]>>,
    default: () => ({ loading: false }),
  },
  shipments: {
    type: Array as PropType<Shipment[]>,
    default: () => [],
  },
});
const { id, shipOrders, shipments } = toRefs(props);

const { t } = useI18n();
</script>
